<template>
  <div>
    <template v-if="media.length === 0">
      <Empty>
        <template #title>
          {{ $t('No media found.') }}
        </template>
      </Empty>
    </template>
    <template v-else>
      <div class="tw:max-h-80 tw:overflow-y-auto tw:bg-zinc-50 tw:rounded-md tw:p-4">
        <div class="tw:grid tw:grid-cols-3 tw:gap-6">
          <template v-for="mediaItem in mediaList" :key="mediaItem.id">
            <button type="button"
                    class=""
                    @click.prevent="onClickMedia(mediaItem)">
              <img :src="mediaItem.url"
                   class="tw:aspect-square tw:w-full tw:object-contain tw:rounded-md tw:border tw:border-zinc-300 tw:bg-white tw:p-4 tw:hover:outline-2 tw:hover:outline-offset-2 tw:hover:outline-blue-500 tw:hover:outline-solid"
                   :alt="mediaItem.name">
            </button>
          </template>
        </div>
      </div>
    </template>
    <div class="tw:mt-4">
      <template v-if="uploadState">
        <div class="tw:flex tw:justify-start tw:items-center tw:py-3 tw:gap-2">
          <loader-circle class="tw:animate-spin tw:size-6 tw:text-blue-500" />
          <span>{{ uploadState === 'uploading' ? $t('Uploading…') : $t('Processing…') }}</span>
        </div>
      </template>
      <template v-else>
        <MediaUploader
          :id="`media-uploader-${props.collectionName}`"
          multiple
          @file-input="onFileInput"
        />
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import MediaUploader from './MediaUploader.vue';
import { useMediaUpload } from '@/composables/useMediaUpload';
import { LoaderCircle } from '@lucide/vue';
import Empty from "@/components/ui/Empty.vue";

const props = withDefaults(defineProps<{
  collectionName: string,
  uploadUrl: string,
  media: Array<any>,
}>(), {
  media : () => [],
});

const mediaList = ref([...props.media]);
watch(props.media, (newMedia) => {
  mediaList.value = [...newMedia];
});

const emit = defineEmits([
  'filesUploaded',
  'mediaSelected',
]);

const {
  uploadState,
  uploadAndProcessFiles
} = useMediaUpload(props.uploadUrl, props.collectionName);

const onFileInput = async (files: FileList) => {
  const updatedFiles = await uploadAndProcessFiles(files);
  mediaList.value = [...mediaList.value, ...updatedFiles];
  emit('filesUploaded', updatedFiles);
};

const onClickMedia = (mediaItem) => {
  emit('mediaSelected', mediaItem);
};


</script>
